import { getSizeValue as l, getSafeGutter as p, sizes as n, validateGutter as u, checkIsCSSLength as g } from "@bedrock-layout/spacing-constants";
import m from "styled-components";
const o = m.div.attrs(
  ({ style: e, theme: t, minItemWidth: r, gutter: s }) => {
    var a;
    const i = (a = l(t, r)) != null ? a : r, d = p(t, s);
    return {
      "data-bedrock-grid": "",
      style: {
        ...e,
        "--gutter": d,
        "--minItemWidth": typeof i == "number" ? `${i}px` : i
      }
    };
  }
)`
  @property --gutter {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 0;
  }

  box-sizing: border-box;
  > * {
    margin: 0;
  }

  display: grid;
  gap: var(--gutter, 0px);

  grid-template-columns: repeat(
    auto-fit,
    minmax(min(var(--minItemWidth, ${n.small}), 100%), 1fr)
  );
`;
o.displayName = "Grid";
function c({ minItemWidth: e }, t) {
  if (e === void 0)
    return;
  typeof e == "number" || g(e) || Object.keys(n).includes(e) || console.error(
    `${t} needs to be an number, CSSLength or SizesOptions`
  );
}
o.propTypes = {
  gutter: u,
  minItemWidth: c
};
export {
  o as Grid
};
